export { TablerIconSlideshow1 } from "./TablerIconSlideshow1";
